import PlanDetailsCompareDialog from './plan-details.vue';
import FullComparisonDialog from './full-comparison-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { mapState } from 'vuex';
import { planTypes, BASE_PLAN_SUB_TYPES } from '@/common/constants';

export default {
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    _planType() {
      if(this.selectedPlan.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC) {
        return planTypes.ZOOM_WHITEBOARD
      } else {
        return planTypes.ZOOM_WHITEBOARD_PLUS
      }
    }
  },
  created() {
    this.planDetailsCompareDialog = new ServiceConfirm(PlanDetailsCompareDialog);
    this.fullComparisonDialog = new ServiceConfirm(FullComparisonDialog);
  },
  methods: {
    async showPlanDetailDialog() {
      // do tracking when open plan details dialog
      this.$tracking.buyInteraction('plan details selected',this.trackingPlanKey);
      await this.planDetailsCompareDialog.confirm({
        planList: this.planList.sort((a, b) => a.cycleValue - b.cycleValue),
        planType: this._planType,
        title: this.title,
        planCategory: this.selectedPlan.category
      });
      await this.fullComparisonDialog.confirm({
        planType: this._planType,
      }).catch(() => {
        if (this.$context.is.modal) {
          this.showPlanDetailDialog();
        }
      });
    },
    async showSwitchPlanDialog() {
      // do tracking when open plan details dialog
      this.$tracking.buyInteraction('plan details selected',this.trackingPlanKey);
      await this.fullComparisonDialog.confirm({
        planType: this._planType,
      });
    }
  },
};
